<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="ShowCompareDialog">对码</el-button>

          <SelectFilter  ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
            @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length > 0">
        <CustomTable ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange"
          :tableHaeder="tableHaeder" :loading="loading" @resetMethod="reset" :tableHeight="tableHeight"
          @onApproveStatusSuccess="getData" :tableCode="route.name">
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.isCompared == 1" v-preventReClick
                  @click="showDetailDialog(scope.row)" class="color-blue">查看详情</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData"
          :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange"
          stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
          <el-table-column prop="hisProjectNo" min-width="100" label="His项目编码">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" v-if="scope.row.isCompared == 1" @click="showDetailDialog(scope.row)">{{ scope.row.hisProjectNo }}</el-link>
                <span v-else>{{ scope.row.hisProjectNo?scope.row.hisProjectNo:'-' }}</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="hisProjectName" show-overflow-tooltip min-width="100"
            label="His项目名称">
            <template slot-scope="scope">
              {{ scope.row.hisProjectName?scope.row.hisProjectName:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="no" label="产品编码" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="isInSuppName" label="有供货目录" min-width="95">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="name" label="产品名称"></el-table-column>
          <el-table-column prop="specName" show-overflow-tooltip min-width="110" label="规格/型号"></el-table-column>
          <el-table-column prop="productRegistCertName" show-overflow-tooltip min-width="110"
            label="产品注册证"></el-table-column>
          <el-table-column prop="productRegistCertNo" :show-overflow-tooltip="true" label="注册证号"></el-table-column>
           <el-table-column prop="medicalInsuranceCategoryNo" min-width="180" :show-overflow-tooltip="true" label="医保代码（20位的）"></el-table-column>
             <el-table-column prop="firstCategory" min-width="120" :show-overflow-tooltip="true" label="医保一级分类"></el-table-column>
             <el-table-column prop="secondCategory" min-width="120" :show-overflow-tooltip="true" label="二级分类"></el-table-column>
             <el-table-column prop="thirdCategory" min-width="120" :show-overflow-tooltip="true" label="三级分类"></el-table-column>
          <el-table-column prop="productCommonName" show-overflow-tooltip min-width="110"
            label="产品通用名">
            <template slot-scope="scope">
              {{ scope.row.productCommonName?scope.row.productCommonName:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="manufacturerName" :show-overflow-tooltip="true" width="120"
            label="生产厂家"></el-table-column>
          <el-table-column prop="isCompared" label="对码状态">
            <template slot-scope="scope">{{
              scope.row.isCompared == 1 ? "已对码" : "未对码"
              }}</template>
          </el-table-column>
          <el-table-column prop="stateName" :show-overflow-tooltip="true" width="120" label="启用"></el-table-column>
          <el-table-column prop="supplierProductStateName" :show-overflow-tooltip="true" width="120"
            label="目录状态"></el-table-column>
          <!-- <el-table-column fixed="right" prop="operation" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.isCompared == 1" v-preventReClick
                @click="showDetailDialog(scope.row)" class="color-blue">查看详情</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="查询计费项目" :visible.sync="open" :center="true" width="60%" :before-close="cancel"
      :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="hisQuery">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="no" label="项目编码">
              <el-input v-model="hisQuery.itemCode" @change="hisSearch"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目名称">
              <el-input v-model="hisQuery.itemName" @change="hisSearch"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="拼音码">
              <el-input v-model="hisQuery.py" @change="hisSearch"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-table :data="hisProjectData" border ref="hisTable" height="500" stripe
            :header-cell-style="{ background: '#DDEBFF' }" style="width: 100%" @selection-change="hisSelectionChange">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="itemCode" :show-overflow-tooltip="true" label="项目编码"></el-table-column>
            <el-table-column prop="itemName" :show-overflow-tooltip="true" label="项目名称"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="validStartDTime" label="有效开始日期"></el-table-column>
            <el-table-column prop="validEndDTime" label="有效结束日期"></el-table-column>
            <el-table-column prop="itemPrice" label="项目单价"></el-table-column>
            <el-table-column prop="itemUnit" label="项目单位"></el-table-column>
          </el-table>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="saveCompare">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看对码结果 -->
    <el-dialog title="已对码记录" :visible.sync="detailVisible" :center="true" width="60%" :before-close="detailDialogClose"
      :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="no" label="产品名称：">
              {{ form.name }}
              <!-- <el-input v-model="form.name"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格型号：">
              {{ form.specName }}
              <!-- <el-input v-model="form.specName"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-table :data="productDetail" border class="table" ref="hisTable" height="500" stripe
          :header-cell-style="{ background: '#DDEBFF' }">
          <el-table-column prop="hisProjectNo" label="项目编码"></el-table-column>
          <el-table-column prop="hisProjectName" label="项目名称"></el-table-column>
          <el-table-column prop="deptName" label="对码科室"></el-table-column>
          <el-table-column label="操作" fixed="right" width="180" align="center">
            <template slot-scope="scope">
              <el-button type="text" icon="el-icon-delete" @click="cancelCompareCode(scope.row)">取消对码</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveCompare">确 定 </el-button>
        <el-button @click="editVisible = false">取 消</el-button>
      </span> -->
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { GetProducts, CompareHisInfo, CancelCompareCode, GetProductDetails } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { IsCompareCodeOptions, WhetherOptions, IsHaveSupplyListOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data() {
    return {
      GetDatasAction: GetProducts,
      // RemoveAction: RemoveStockUpApply,
      // PrintAction: GetAcceptInStockPrintData,
      // editPath: 'stock-up-apply-edit',

      IsCompareCodeOptions: IsCompareCodeOptions,
      WhetherOptions: WhetherOptions,
      IsHaveSupplyListOptions: IsHaveSupplyListOptions,
      filterOptions: [
        {
          name: "项目编码",
          type: "input",
          code: "hisProjectNo",
        },
        {
          name: "项目名称",
          type: "input",
          code: "hisProjectValue",
        },
        {
          name: "对码状态",
          type: "select",
          code: "isCompared",
          data: IsCompareCodeOptions,
        },
        {
          name: "产品编码",
          type: "input",
          code: "no",
        },
        {
          name: "产品名称",
          type: "input",
          code: "name",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "启用",
          type: "select",
          code: "state",
          data: WhetherOptions,
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "有供货目录",
          type: "select",
          code: "isInSupp",
          defaultValue: 1,
          data: IsHaveSupplyListOptions,
        },
        {
          name: "目录状态",
          type: "select",
          code: "supplierProductState",
          defaultValue: 1,
          data: WhetherOptions,
        },

      ],
     
      open: false,
      form: {},
      detailVisible: false,
      hisQuery: {},
      hisSelection: [],
      hisProjectData: [],
      productDetail: [],
    };
  },
  methods: {
    ShowCompareDialog() {
      // 选中的数据条数
      const length = this.multipleSelection.length;
      if (length === 0) {
        this.$my_message("请选择数据", "warning");
        return;
      }

      this.open = true;
    },
    hisSearch() {
      var params = [];
      if (this.hisQuery.itemCode) {
        params.push({ key: "itemCode", value: this.hisQuery.itemCode, like: 1 });
      }
      if (this.hisQuery.itemName) {
        params.push({ key: "itemName", value: this.hisQuery.itemName, like: 1 });
      }
      if (this.hisQuery.py) {
        params.push({ key: "py", value: this.hisQuery.py, like: 1 });
      }

      var param = {
        Request: {
          Head: {
            Version: "1.1",
            LicId: "MDM",
            TranCode: "ChargeItem",
            ServiceVersion: "5.0.2",
            ContentType: "text/json",
            OrgId: "45206679-9",
            AppId: "HIS0316",
            RecOrgId: "45206679-9",
            RecAppId: "MDM",
            Timestamp: this.parseTime(new Date()), // new Date().format('yyyy-MM-dd hh:mm:ss'),
            MessageId: "0188DB61-5194-4E91-AB95-142EB10548BA",
          },
          Body: {
            Page: 1,
            PageSize: 100,
            Params: params,
          },
        },
      };
      this.$axios.post(`${config.MDMHost}/mdm/public/query`, param).then((res) => {
        var result = res.data;
        if (!result.Response.Head.AckMessage && result.Response.Head.AckMessage != "") {
          this.$my_message(result.Response.Head.AckMessage, "warning");
        }

        this.hisProjectData = result.Response.Body.DataItems.sort(this.compare).reverse();
      });
    },

    // hisSearch () {
    //   var arr = [
    //     { itemCode: 'a008', itemName: '33' },
    //     { itemCode: 'a007', itemName: '34' },
    //     { itemCode: 'b006', itemName: '35' },
    //     { itemCode: 'a005', itemName: '34' },
    //     { itemCode: 'b004', itemName: '35' },
    //     { itemCode: 'a003', itemName: '34' },
    //     { itemCode: 'b002', itemName: '35' },
    //     { itemCode: 'a001', itemName: '34' },
    //     { itemCode: 'b011', itemName: '35' },
    //     { itemCode: 'a017', itemName: '34' },
    //     { itemCode: 'b018', itemName: '35' },
    //     { itemCode: 'a0157', itemName: '34' },
    //     { itemCode: 'b0158', itemName: '35' },
    //     { itemCode: 'a0137', itemName: '34' },
    //     { itemCode: 'b0128', itemName: '35' },
    //     { itemCode: 'a0117', itemName: '34' },
    //     { itemCode: 'b0108', itemName: '35' },
    //     { itemCode: 'a097', itemName: '34' },
    //     { itemCode: 'b088', itemName: '35' },
    //     { itemCode: 'a077', itemName: '34' },
    //     { itemCode: 'b068', itemName: '35' }
    //   ]
    //   this.hisProjectData = arr.sort(this.compare).reverse()
    // },
    compare(obj1, obj2) {
      var val1 = obj1.itemCode;
      var val2 = obj2.itemCode;
      if (val1 < val2) {
        return 1;
      } else if (val1 > val2) {
        return -1;
      } else {
        return 0;
      }
    },
    saveCompare() {
      // 添加一个置空的
      const length = this.hisSelection.length;
      if (length !== 1) {
        this.$my_message("需要选择一条his计费项目", "warning");
        return;
      }
      var productIds = this.multipleSelection.map((e) => e.id);
      var query = {
        ProductIds: productIds,
        HisProjectNo: this.hisSelection[0].itemCode,
        HisProjectName: this.hisSelection[0].itemName,
        UserId: this.userInfo.id,
        DeptId: this.userInfo.deptId,
      };

      CompareHisInfo(query).then((res) => {
        this.open = false;
        this.$my_message(`提交成功`, "success");
        this.multipleSelection = [];
        this.hisSelection = [];
        this.hisQuery = {
          itemCode: "",
          itemName: "",
        };
        this.hisProjectData = [];
        this.$refs.multipleTable.clearSelection();
        this.$refs.hisTable.clearSelection();
        this.getData();
      });
    },

    cancelCompareCode(row) {
      CancelCompareCode({ productDetailId: row.id }).then((res) => {
        this.$my_message(`提交成功`, "success");
        this.getProductDetails(row.parentId);
      });
    },

    cancel() {
      this.open = false;
    },

    showDetailDialog(row) {
      this.detailVisible = true;
      this.form = row;
      this.getProductDetails(row.id);
    },
    detailDialogClose() {
      this.detailVisible = false;
      this.getData();
    },
    getProductDetails(productId) {
      GetProductDetails({ productId: productId }).then((res) => {
        this.productDetail = res.returnData;
      });
    },

    hisSelectionChange(val) {
      this.hisSelection = val;
    },
  },
  mounted() { 
  },
};
</script>

<style lang="scss" scoped></style>
